import { useCallback, useState } from "react";
import AwaitType from "../../../utils/AwaitType";
import { createOfficer, TCreateOfficerData, updateOfficer } from "../network";
import { ActionType } from "../../../models/ActionType";

export type TResult = null | AwaitType<ReturnType<typeof createOfficer>>;

export const useOfficerAction = (): [
  TResult,
  boolean,
  Error | null,
  (data: TCreateOfficerData, mode: ActionType, officerId?: string) => void,
  () => void
] => {
  const [result, setResult] = useState<TResult>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(
    async (data: TCreateOfficerData, mode: ActionType, officerId?: string) => {
      setIsLoading(true);
      setError(null);

      try {
        const response =
          mode === ActionType.CREATE
            ? await createOfficer(data)
            : await updateOfficer(officerId!, data);
        setResult(response);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error("Unknown error"));
        }
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return [result, isLoading, error, request, clearError];
};
